export default __webpack_public_path__ + "static/media/spotify.5c399e5b.svg";